import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useEffect } from "react"
import { useUIStore } from "@/store/ui"

export const Route = createFileRoute("/add")({ component: AddShortcut })

/**
 * Target of the "Add transaction" app shortcut (long-press the home-screen icon).
 * Same hand-off as the tab bar's Add button: open the transactions page's Add dialog.
 */
export function AddShortcut() {
  const navigate = useNavigate()
  const setPendingAction = useUIStore((s) => s.setPendingAction)
  useEffect(() => {
    setPendingAction("add_transaction")
    navigate({ to: "/transactions", replace: true })
  }, [navigate, setPendingAction])
  return null
}
